import React from 'react'
import PropTypes from 'prop-types'

const Form = props => (
  <form
    className="form-horizontal"
    role="form"
    onSubmit={props.editTag(props.data)}
  >
    <div className="portlet light">
      <div className="portlet-title">
        <div className="caption">
          <span className="caption-subject bold uppercase">Edit an tag</span>
        </div>
      </div>
      <div className="portlet-body">
        <div className="form-body">
          <div className="form-group">
            <label htmlFor="name" className="col-md-3 control-label">
              The name of the tag is
            </label>
            <div className="col-md-9">
              <input
                type="hidden"
                className="form-control"
                value={props.data.id}
              />
              <input
                type="text"
                className="form-control"
                placeholder="Enter text"
                value={props.data.name}
                name="name"
                onChange={props.handleFormChange(props.data)}
              />
            </div>
          </div>
          <div className="form-actions">
            <div className="row">
              <div className="col-md-offset-3 col-md-9">
                <button type="submit" className="btn btn-lg btn-primary">Submit</button>
                <button
                  type="button"
                  className="btn btn-lg default"
                  onClick={props.handleCancel}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
)

Form.defaultProps = {
  tag: {
    id: '',
    name: '',
  },
}

Form.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  editTag: PropTypes.func.isRequired,
  handleFormChange: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
}

export default Form
